
<app-mainscreen>
    <app-simple-page-heading [breadcrumbs]="['Dashboard > Reports']" title="Reports" ></app-simple-page-heading>
    <div class="mt-2"></div>
    <div class="box-container p-2" style="min-height: 65vh;">
        <div class="row mb-3">
            <div class="col-3">
                <select class="form-select" (change)="reportChange($event)">
                    <option [value]="item.value" *ngFor="let item of reportList">{{item.text}}</option>
                </select>
            </div>
        </div>
        <div class="row mb-2" *ngIf="required_input_fields?.filterFormFields?.length??0 > 0">
            <app-report-dynmic-filters [id]="'rpt'"                 
                (applyButtonEvent)="applyButtonClick($event)"
                [required_input_fields]="required_input_fields??{}"
                [questionFor]="'rpt'">
            </app-report-dynmic-filters>         

        </div>
        <ng-container *ngIf="requestData?.for != null && requestData?.for != undefined && requestData?.for != ''">
            <app-table-view
            [visibleColumnData] = "visibleColumnData"
            [visibleColumnsId] = "visibleColumnsId"
            [graphdata]="graphdata"
            [graphHeader]="graphHeader"
            title="{{reportTitle}}"
            tableBackground="var(--grey3)"
            buttonTitle="Create Distributor"
           [showIconButtonEnd]="true"
            [showPaginator]="true"  
            (onActionClick)="onActionClick($event)"
            (onCreateBtnClick)="onCreateBtnClick($event)"
            [canCreate]="canCreate"
            [canView]="canView"
            [canDelete]="canDelete"
            [canEdit]="canEdit"
            [showLoader]="showLoader"
          ></app-table-view>
        </ng-container>        
    </div>

</app-mainscreen>